'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPreviousId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_UNIQUE_USER_ID);
}

exports.default = getPreviousId;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/cookie/getPreviousId.js
// module id = 1765
// module chunks = 1